import OrdersCollection from '../classes/OrdersCollection'

(function() {
  
  'use strict';
  
  angular
  .module('ATMGCart')
  .service('Cart', Cart);
  
  Cart.$inject = ['CartService', '$q'];
  
  function Cart(CartService, $q) {
    
    // make CartService available for the whole class
    this.CartService = CartService;
    
    // Promises to ease returns
    this.$q = $q;
    
    // lock status with Cartservice
    this.status = CartService.status;
    
    return this.reset();
    
  }
  
  //////////////////////////// RESET
  
  Cart.prototype.reset = function cartReset() {
    
    // number of items in the cart
    this.items_count = '0';
    
    // cart is locked
    this.status.locked = false;
    
    // cart is being charged
    this.status.charging = false;
    
    // cart mode [edit | view]
    this.mode = 'edit';
    
    // orders
    this.resetOrders();
    
    // cart id, in case we are processing one
    this.cart_id = undefined;
    
    // callback function being fired on cart update
    // client code can define a function(Promise)
    this.cartUpdated = undefined;
    
    // cart is aware if it has been fully init
    this.fullyInit = false;
    
    return this;
  }
  
  //////////////////////////// INIT
  
  /**
  *   init
  *   takes charge of the whole cart init process
  */
  Cart.prototype.init = function(cart_id) {
    var defer = this.$q.defer();
    
    // set cart mode
    this.mode = cart_id ? 'view' : 'edit';
    
    // @TODO i'm not sure why we conditionally reset orders
    // evaluate whether reset orders before init
    this.shouldResetOrders = false;
    
    // edit mode inits
    if (this.mode === 'edit') {
      this.fetchItemsCount();
      this.shouldResetOrders = false;
      // view mode inits
    } else {
      this.shouldResetOrders = true;
      this.cart_id = cart_id;
    }
    
    // fetch whole cart after check has been called
    this.check()
      .then(function() {
        // if check starts orders we cannot reset them, otherwise we loose error messages
        // but if we don't reset orders when switching carts we have a problem, because
        // old orders are not being cleared
        return this.content(this.shouldResetOrders, cart_id)
      }.bind(this))
        .then(function() {
          this.fullyInit = true;
          defer.resolve(true);
      }.bind(this))
    
    // we override this on confirmation/single order
    // make sure this is available when needed
    this.getOrders = function getOrders() {
      return this.orders.orders;
    }

    this.getOrdersCollection = function() {
      return this.orders
    }
    
    return defer.promise;
  }
  
  /**
  *   quickInit
  *   quickinit just returns the count
  */
  Cart.prototype.quickInit = function quickInit() {
    return this.fetchItemsCount();
  }
  
  /**
  *   count
  *   return # of items in the cart
  */
  Cart.prototype.fetchItemsCount = function count(cart_id) {
    this.CartService.count(cart_id)
    .then(function countResolved(response) {
      this.items_count = parseInt(response.data);
      return this.items_count;
    }.bind(this))
  }
  
  /**
  *   Content
  *   Fetch cart content
  *   @return Promise
  */
  Cart.prototype.content = function loadContent(reset, cart_id) {
    var defer = this.$q.defer();
    
    // manage loading by handling all the requests as a single promise
    // returning when we're done
    var initTasksQueue = ['details', 'lines', 'totals'];
    
    // check wether the init tasks are completed
    function checkQueue(item) {
      initTasksQueue.splice(initTasksQueue.indexOf(item), 1);
      if (initTasksQueue.length === 0) {
        defer.resolve(true);
      }
    }
    
    initTasksQueue.forEach(function(task) {
      this[task](reset, cart_id)
      .then(function() {
        checkQueue(task);
      });
    }, this);
    
    return defer.promise;
    
  }
  
  /**
  *   Lines
  *   grab orders headers and line items, building the cart content
  *   @NOTE lines and headers are grouped
  */
  Cart.prototype.lines = function lines(reset, cart_id) {
    var defer = this.$q.defer();
    // fetch orders headers
    this.headers(reset, cart_id);
    // Lines
    return this.CartService.lines(cart_id)
    .then(function linesResolved(response) {
      var orders = response.data;
      for (var orderNr in orders) {
        this.orders.addToOrder(orderNr, orders[orderNr]);
      }
      defer.resolve(response);
    }.bind(this))
    return defer.promise
  }
  
  /**
  *   Headers
  *
  */
  Cart.prototype.headers = function fetchHeaders(reset, cart_id) {
    var defer = this.$q.defer();
    this.CartService.headers(cart_id)
    .then(function headersResolved(response) {
      if (reset) this.resetOrders();
      response.data.forEach(function(orderData) {
        // in view mode fetch all orders details
        if (this.mode === 'view') {
          this.CartService.orderTotals(orderData.order_number)
          .then(function(response) {
            _.extend(orderData, response.data)
            this.orders.addOrder(orderData)
          }.bind(this))
        } else {
          this.orders.addOrder(orderData)
        }
      }, this)
      defer.resolve(response)
    }.bind(this))
    return defer.promise
  }
  
  /**
  *   Totals
  *
  */
  Cart.prototype.totals = function totals(reset, cart_id) {
    var defer = this.$q.defer();
    this.CartService.totals(cart_id)
    .then(function totalsResolved(response) {
      _.extend(this, response.data);
      defer.resolve(response);
    }.bind(this));
    return defer.promise
  }
  
  /**
  *   Details
  *
  */
  Cart.prototype.details = function details(reset, cart_id) {
    var defer = this.$q.defer();
    this.CartService.details(cart_id)
    .then(response => {
      if (response.data.cart_status === 'FREIGHT QUOTE READY') {
        this.lock('Freight quote ready');
      }
      _.extend(this, response.data);
      defer.resolve(response);
    })
    return defer.promise
  }
  
  ///////////////////////// MESSAGES / VALIDATION
  
  /**
  *   Check
  *
  */
  Cart.prototype.check = function cartCheckRoutine() {
    var defer = this.$q.defer();
    this.CartService.check()
    .then(function (response) {
      if (response.success) {
        this.orders.addInfo(response.data)
      } else {
        throw 'Cart check returned unsuccesfully';
      }
      defer.resolve(response);
    }.bind(this))
    return defer.promise
  }
  
  /**
  *   Validation
  *
  */
  Cart.prototype.validate = function validate() {
    var defer = this.$q.defer();
    this.CartService.validate()
    .then(function headersResolved(response) {
      defer.resolve(response);
    }.bind(this));
    return defer.promise;
  }
  
  ///////////////////////// CART STATUS
  
  Cart.prototype.lock = function(reason) {
    reason = reason ? reason : 'reason unknown';
    // console.log("Locking Cart for: " + reason);
    this.status.locked = true;
    
    // make sure items_count is populated, we might be locking
    // the cart because we're seeing a freight quote ready, which
    // means we want the items count
    return this.fetchItemsCount(this.cart_id);
  };
  
  
  ///////////////////////// CART HANDLING
  
  /**
  *   Reset orders
  *
  */
  Cart.prototype.resetOrders = function resetOrders() {
    this.orders = new OrdersCollection();
  }
  
  /**
  *   Add
  *
  */
  Cart.prototype.addItem = function addItem(lineItem) {
    //Analytics.addItem(lineItem.order_number,lineItem.item_primary_key,lineItem.item_group,lineItem.description,lineItem.selling_price,lineItem.quantity);

    return this.manipulate('add', {
      item_id: lineItem.item_id,
      quantity: lineItem.quantity
    });
  }
  
  /**
  *   Remove
  *
  */
  Cart.prototype.removeItem = function removeItem(lineItem) {
    return this.manipulate('remove', {
      item_id: lineItem.item_primary_key
    });
  }
  
  /**
  *   Update
  *
  */
  Cart.prototype.updateItem = function updateItem(lineItem) {
    return this.manipulate('update', {
      item_id: lineItem.item_primary_key,
      quantity: lineItem.quantity
    });
  }
  
  /**
  *   Manipulate
  *
  */
  Cart.prototype.manipulate = function manipulate(action, payload) {
    var defer = this.$q.defer();
    this.CartService[action](payload)
      .then(response => {
        if (response.success) {
          // refresh count
          this.fetchItemsCount();
          // if not displaying the full cart stop here
          if (!this.fullyInit) {
            return defer.resolve(response);
          }
          // refresh content
          this.content(true, null)
            .then(function() {
              // perform cart check (blocking)
              return this.check()
              .then(function() {
                defer.resolve(true)
              })
            }.bind(this))
        }
      })
      .catch(error => {
        throw error;
        return defer.reject(error);
      })
    // if a callback is set for manipulate updates
    if (! _.isUndefined(this.cartUpdated)) {
      return this.cartUpdated(defer.promise);
    } else {
      return defer.promise;
    }
    
  }
  
  /**
  *  Get Customer Notes
  */
  Cart.prototype.getCustomerNote = function(line_item) {
    if (this.mode === 'edit') {
      return this.CartService.getCustomerNote(line_item)
    } else if (this.mode === 'view') {
      return this.CartService.getCustomerNote(line_item, this.cart_id)
    }
  }
  
  /**
  *  Get Customer Notes
  */
  Cart.prototype.setCustomerNote = function(line_item, note) {
    return this.CartService.setCustomerNote({line_id: line_item, note: note})
  }
  
  /**
  *   Charge
  *
  */
  Cart.prototype.charge = function chargeOrder(payload) {
    var defer = this.$q.defer();
    
    this.status.charging = true;

    let cart_id = this.cart_id && this.status.locked ? this.cart_id : undefined

    this.CartService.charge(payload, cart_id)
      .then((response) => {
        this.status.charging = false;
        if (response.success) {
          this.reset()
          return defer.resolve(response.data)
        } else {
          this.resetOrders()
          return defer.reject(response)
        }
      })
      .catch(response => {
        this.resetOrders()
        this.status.charging = false;
        this.content(false, null);
        defer.reject(response);
      })
    
    return defer.promise;
  }
  
  ///////////////////////// BACKWARD COMPATIBILITY
  
  // Cart.prototype.getOrders = function() {
    //     return this.orders.orders;
    // }
    
    Cart.prototype.locked = function() {
      return this.status.locked;
    }
    
    Cart.prototype.getItemsCount = function() {
      return parseInt(this.items_count);
    }
    
    Cart.prototype.net_terms_only = function() {
      return false;
    }

    Cart.prototype.isPromo = function(line_item) {
      return (line_item.item_primary_key === 'PROMO');
    }

    Cart.prototype.refreshCart = function(reset, cart_id) {
      var defer = this.$q.defer();
      this.fetchItemsCount();
      if (!this.fullyInit) {
        return defer.resolve(response);
      }
      var initTasksQueue = ['lines', 'totals', 'check'];
      function checkQueue(item) {
        initTasksQueue.splice(initTasksQueue.indexOf(item), 1);
        if (initTasksQueue.length === 0) {
          defer.resolve(true);
        }
      }
      initTasksQueue.forEach(function(task) {
        this[task](reset, cart_id)
        .then(function() {
          checkQueue(task);
        });
      }, this);
      return defer.promise;
    }
    
  })()



// WEBPACK FOOTER //
// ./src/app/modules/Cart/services/Cart.js